import { ConceptNodeMap } from "../../Concepts.interface";

export const isAncestorSelected = (
  id: string,
  selected: Set<string>,
  treeMap: ConceptNodeMap,
) => {
  let currentId = id;
  while (treeMap[currentId]?.parentId) {
    const parentId = treeMap[currentId]?.parentId;
    if (selected.has(parentId as string)) return true;
    currentId = parentId || "";
  }
  return false;
};
